function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M33.7 66.802c18.06 0 32.7-14.64 32.7-32.7 0-18.06-14.64-32.7-32.7-32.7-18.06 0-32.7 14.64-32.7 32.7 0 18.06 14.64 32.7 32.7 32.7z",
  fill: "currentColor",
  stroke: "currentColor",
  strokeWidth: 1.8
});

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "NewsLetterIcon_svg__paint0_linear",
  x1: 1,
  y1: 1.402,
  x2: 1,
  y2: 66.802,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", null), /*#__PURE__*/React.createElement("stop", {
  offset: 0.999
})));

var SvgNewsLetterIcon = function SvgNewsLetterIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 68 68",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNjgiIGhlaWdodD0iNjgiIHZpZXdCb3g9IjAgMCA2OCA2OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMzLjcgNjYuODAyMkM1MS43NTk3IDY2LjgwMjIgNjYuNCA1Mi4xNjE5IDY2LjQgMzQuMTAyMkM2Ni40IDE2LjA0MjUgNTEuNzU5NyAxLjQwMjIyIDMzLjcgMS40MDIyMkMxNS42NDAzIDEuNDAyMjIgMSAxNi4wNDI1IDEgMzQuMTAyMkMxIDUyLjE2MTkgMTUuNjQwMyA2Ni44MDIyIDMzLjcgNjYuODAyMloiIGZpbGw9IiMwMDAwMDAiIHN0cm9rZT0iIzAwMDAwMCIgc3Ryb2tlLXdpZHRoPSIxLjgiLz4KPGRlZnM+CjxsaW5lYXJHcmFkaWVudCBpZD0icGFpbnQwX2xpbmVhciIgeDE9IjEiIHkxPSIxLjQwMjIyIiB4Mj0iMSIgeTI9IjY2LjgwMjIiIGdyYWRpZW50VW5pdHM9InVzZXJTcGFjZU9uVXNlIj4KPHN0b3Agc3RvcC1jb2xvcj0iIzAwMDAwMCIvPgo8c3RvcCBvZmZzZXQ9IjAuOTk4NjI4IiBzdG9wLWNvbG9yPSIjMDAwMDAwIi8+CjwvbGluZWFyR3JhZGllbnQ+CjwvZGVmcz4KPC9zdmc+Cg==";
export { SvgNewsLetterIcon as ReactComponent };